/*
 * @Description: 用户登录状态模块
 * @Author: loong
 * @Date: 2022-09-08 14:56:02
 * @LastEditors: loong
 * @LastEditTime: 2022-09-23 14:34:22
 */
import * as contUrl from '../../const';
import http from '../../utils/http';
import cookie from '../../utils/cookie.js';
export default {
  namespaced: true,
  state: {
    userInfo: {}, // 登录的用户
    isLogin:false,
  },
  getters: {

  },
  mutations: {
    setuserInfo(state, data) {
      state.userInfo = data;
    },
    getUserINFO(state, data) {
      state.userInfo = data;
      state.isLogin = true;
    },
    loginOut(state, data) {
      state.userInfo={};
      state.isLogin=false;
      cookie.delete('PIE_MALL_Token')
    },

  },
  actions: {
    updateuserInfo({commit}, data) {
      commit('setuserInfo', data);
    },
    getUserINFO({commit}, data) {
      return new Promise((resolve,reject)=>{
        http.get(contUrl.common.GETuserInfo,"",true).then(res=>{
          // 请求成功
          console.log('res',res);
          cookie.set('userCreateBy', res.user.userName)
          commit('getUserINFO', res.user);
          if(res.code=='-1'){
            // commit('loginOut', data);
      cookie.delete('PIE_MALL_Token')

          }
          // 如果是一个请求，更改多个state里面的数据，就调用mutations对应的修改方法～
          resolve() // 通知组件，接口调用成功了
        }).catch(err=>{
          reject(err) // 通知组件，接口调用失败，并把失败原因传过去
        })
      })
    },
    loginOut({commit}, data) {
      return new Promise((resolve,reject)=>{
        http.post(contUrl.common.cpeosLogout,"",true).then(res=>{
          commit('loginOut', data);
          // 如果是一个请求，更改多个state里面的数据，就调用mutations对应的修改方法～
          resolve() // 通知组件，接口调用成功了
        }).catch(err=>{
          reject(err) // 通知组件，接口调用失败，并把失败原因传过去
        })
      })
    },
  }
}
